import React, { createContext, useReducer } from 'react';
import { useSelector } from 'react-redux';

import Reducer from '../reducer/reducer';

let INITIAL_STATE = {
	loaded: false,
};

const Store = ({ state, children }) => {
	state = state || { loaded: false };

	const { DisableLazyLoad } = useSelector(
		({ featureSwitches }) => featureSwitches
	);

	if (DisableLazyLoad) {
		state = { loaded: true };
	}

	const [contextState, dispatch] = useReducer(Reducer, state);

	return (
		<Context.Provider value={[contextState, dispatch]}>
			{children}
		</Context.Provider>
	);
};

export const Context = createContext(INITIAL_STATE);
export default Store;
